export default __webpack_public_path__ + "static/media/hero-seven-bg.26115e7f.png";